import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-sandbox-recp-status',
  template: `
    <div class="status-title d-flex align-items-center">
      <span ngClass="status-circle-main {{statusClass}} mr-2"><span class="status-circle-sm" ngClass="{{statusClass}}"></span></span>
      {{statusText}}
      <div class="status-info">
        <a class="status-link text-link" href="javascript:void(0)" (click)="onResendClick()"
           ngbTooltip="Resend Confirmation Link">{{statusLinkText}}</a>
      </div>
    </div>
  `,
  styles: []
})
export class TableSandboxRecpStatusComponent implements ViewCell, OnInit {

  // renderValue: boolean;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() resendClick: EventEmitter<any> = new EventEmitter();

  statusText: string;
  statusLinkText: string;
  statusClass: string;

  ngOnInit() {
    if (+this.rowData.status === 1) {
      this.statusText = 'Verified';
      this.statusClass = 'active';
    } else if (+this.rowData.status === 2) { // for account used in subaccont
      this.statusText = 'Account Disabled';
      this.statusClass = 'rejected';
    } else {
      this.statusText = 'Unverified';
      this.statusLinkText = 'Resend';
      this.statusClass = 'not-verified';
    }
  }

  onResendClick() {
    this.resendClick.emit(this.rowData);
  }


}
